import React from 'react';
import { RefreshCw } from 'lucide-react';

const ProgressOverlay = ({ isVisible, message = 'Processing...', count = 0 }) => {
  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white dark:bg-gray-800 rounded-lg p-6 shadow-xl max-w-md w-full mx-4">
        <div className="flex flex-col items-center space-y-4">
          {/* Spinner */}
          <RefreshCw className="w-8 h-8 text-blue-600 dark:text-blue-400 animate-spin" />
          
          {/* Message */}
          <div className="text-center">
            <h3 className="text-lg font-medium text-gray-900 dark:text-gray-100 mb-2">
              Recalculating Pricing
            </h3>
            <p className="text-sm text-gray-600 dark:text-gray-400">
              {message}
              {count > 0 && ` (${count} products)`}
            </p>
            <p className="text-xs text-gray-500 dark:text-gray-500 mt-2">
              Please wait while we update the pricing data...
            </p>
          </div>
          
          {/* Progress Bar */}
          <div className="w-full bg-gray-200 dark:bg-gray-700 rounded-full h-2">
            <div className="bg-blue-600 dark:bg-blue-400 h-2 rounded-full animate-pulse" style={{ width: '75%' }}></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProgressOverlay;